/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import UDCEntryPhase from 'components/content/userdatacollection/phases/udcentry/udcentry_container'
import UDCSuccessPhase from 'components/content/userdatacollection/phases/udcsuccess/udcsuccess_container';
import UDCFailurePhase from 'components/content/userdatacollection/phases/udcfailure/udcfailure_container';
import UDCFetchingPhase from 'components/content/userdatacollection/phases/udcfetching/udcfetching';

import Structure from 'components/shared/structure/structure_container';
// unique elements
import Frame from 'components/frames/frame_container';
// utils
import { log } from 'utils/logger';
import { url } from 'utils/urls';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/userdatacollection/userdatacollection_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, { link: true });



/* ========== ~~~~~~~~~~ USER DATA COLLECTION: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class UserDataCollection extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (this.isReadyToFetch()) this.fetchUDCSettings();
    if (!prevProps.phase && this.props.phase === 'rejected') this.props.deactivateContents([this.props.contentId])
    if (!this.props.isActive && prevProps.isActive) this.props.setUniqueState(this.props.contentId, { phase: null })
  }

  isReadyToFetch = () => {
    const { phase, isActive, dataFetchingPermitted } = this.props;
    return !phase && isActive && dataFetchingPermitted
  };

  fetchUDCSettings = () => {
    const { embedUUID, contentId, userId, isPubPortalPreview } = this.props;
    return this.props.getUDCSettings(embedUUID, contentId, userId, isPubPortalPreview);
  };

  getPhaseComponent = () => {
    switch (this.props.phase) {
      case 'entry':
        return <UDCEntryPhase contentId={this.props.contentId} />;
      case 'success':
        return <UDCSuccessPhase contentId={this.props.contentId} />;
      case 'failure':
        return <UDCFailurePhase contentId={this.props.contentId} />;
      case 'fetching':
        return <UDCFetchingPhase contentId={this.props.contentId} />;
      default:
        return null;
    }
  };

  createFrames = () => <Frame id={this.props.contentId}
    type={'udc'}
    frameIndex={0}
    contentId={this.props.contentId}
    markup={this.getPhaseComponent()} />;

  render() {
    if (!this.props.phase || this.props.phase === 'rejected') return null;
    return (
      <div className={`${sheet.classes.uniquecontent} uniquecontent ${this.props.currentContentStatusType}`}>
        <Structure contentId={this.props.contentId}
          screenBGImg={!!this.props.backgroundImageURL ? this.props.backgroundImageURL : 'none'}
          screenBGColor={this.props.backgroundColor}
          markup={this.createFrames()} />
      </div>
    );
  }
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UserDataCollection;
